/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Enter_FullscreenInputs */

const cs_workflow_enter_fullscreen = /** @type {(inputs: Workflow_Enter_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na celou obrazovku`)
};

const en_workflow_enter_fullscreen = /** @type {(inputs: Workflow_Enter_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter fullscreen`)
};

/**
* | output |
* | --- |
* | "Enter fullscreen" |
*
* @param {Workflow_Enter_FullscreenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_enter_fullscreen = /** @type {((inputs?: Workflow_Enter_FullscreenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Enter_FullscreenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_enter_fullscreen(inputs)
	return cs_workflow_enter_fullscreen(inputs)
});